import type {ProForm} from './types';

import {Button} from '@ds/components';
import {PageLayout} from '@ds/layout';
import {toast} from '@Toast';
import {useState} from 'react';
import {useAppDispatch, useAppSelector} from 'store';
import {createVendorProSnapshot} from 'store/slices/vendor-pro/thunk';

import ProAreaSelect from '../components/common/ProAreaSelect/ProAreaSelect';
import {getProVendorId} from '../utils';
import ProOtpSheet from './components/ProOtpSheet/ProOtpSheet';
import ProRangePicker from './components/ProRangePicker/ProRangePicker';
import ProReview from './components/ProReview/ProReview';
import {INITIAL_PRO_FORM} from './constants';

const ProAdd: React.FC = () => {
  const vendorId = getProVendorId();
  const dispatch = useAppDispatch();
  const {create} = useAppSelector((state) => state.vendorPro);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState<ProForm>(INITIAL_PRO_FORM);
  const [isOtpOpen, setIsOtpOpen] = useState(false);

  const goToNextStep = () => {
    if (step === 3) {
      return;
    }

    setStep((current) => current + 1);
  };

  const goToPreviousStep = () => {
    if (step === 1) {
      return;
    }

    setStep((current) => current - 1);
  };

  const submitForm = async () => {
    try {
      await dispatch(
        createVendorProSnapshot({
          vendor_id: vendorId as number,
          start_date: new Date(form.date.start as string),
          polygon_ids: form.polygonIds as number[]
        })
      ).unwrap();
      setIsOtpOpen(true);
    } catch (error) {
      const requestError = error as {data?: {errors?: {message?: string}}};
      toast(requestError.data?.errors?.message || 'مشکلی پیش آمده. دوباره تلاش کنید!');
    }
  };

  return (
    <PageLayout
      footerPosition="static"
      footer={
        <>
          {step === 1 ? (
            <Button onClick={goToNextStep} fullWidth disabled={!form.polygonIds.length}>
              فعال سازی
            </Button>
          ) : null}
          {step === 2 ? (
            <>
              <Button fullWidth size="lg" onClick={goToPreviousStep} variant="ghost">
                مرحله قبل
              </Button>
              <Button fullWidth size="lg" onClick={goToNextStep} disabled={!form.date.start}>
                مرحله بعد
              </Button>
            </>
          ) : null}
          {step === 3 ? (
            <>
              <Button onClick={goToPreviousStep} variant="ghost" fullWidth size="lg">
                مرحله قبل
              </Button>
              <Button onClick={() => void submitForm()} loading={create.loading} fullWidth>
                تایید
              </Button>
            </>
          ) : null}
        </>
      }
    >
      {step === 1 ? (
        <ProAreaSelect
          vendorId={vendorId}
          onChange={({polygonIds = [], selectedPolygons = {}}) => {
            setForm((current) => ({
              ...current,
              polygonIds,
              coverage: polygonIds.length,
              selectedPolygons
            }));
          }}
        />
      ) : null}
      {step === 2 ? (
        <ProRangePicker
          date={form.date}
          onChangeDate={(date) => setForm((current) => ({...current, date}))}
        />
      ) : null}
      {step === 3 ? <ProReview form={form} onPreviousStepClick={goToPreviousStep} /> : null}
      <ProOtpSheet
        vendorId={vendorId}
        isOpen={isOtpOpen}
        onClose={() => setIsOtpOpen(false)}
        onSubmitFormClick={submitForm}
      />
    </PageLayout>
  );
};

export default ProAdd;
